export default "__VITE_ASSET__72ab3956__"